import React from 'react'
import { Account } from '@ally/data-types-afg-accounts'
import { Box } from '@ally/metronome-ui'
import { asCurrency } from '@ally/aos-utils'
import { STALE_DATA_COPY } from '../../constants'
import { getDashDash } from '../../utils'
import MobileCardDetail from './MobileCardDetail'
import {
  StyledAccountDetailsLink,
  TotalBalanceContainer,
} from './MobileDepositAccountList'

const TotalAvailableBalance: React.FC<{
  accounts: Account[]
  hasStaleData?: boolean
}> = ({ accounts, hasStaleData }) => {
  const total = accounts.reduce((sum, account) => {
    return (account.value?.total ?? 0) + sum
  }, 0)

  return (
    <TotalBalanceContainer>
      <Box fontWeight="bold">Total</Box>
      <Box fontWeight="bold">
        {hasStaleData ? getDashDash(STALE_DATA_COPY) : asCurrency(total)}
      </Box>
    </TotalBalanceContainer>
  )
}

const MobileInvestAccountList: React.FC<{
  accounts: Account[]
  allClosedAccounts: boolean
  hasStaleData?: boolean
}> = ({ accounts, allClosedAccounts, hasStaleData }) => {
  return (
    <>
      {accounts.map((account: Account) => {
        const content = (
          <MobileCardDetail
            account={account}
            key={`detail-${account.id}`}
            hasStaleData={hasStaleData}
          />
        )

        return (
          <StyledAccountDetailsLink
            key={account.id}
            account={account}
            text={content}
            hasStaleData={hasStaleData}
          />
        )
      })}
      {!allClosedAccounts && (
        <TotalAvailableBalance
          accounts={accounts}
          hasStaleData={hasStaleData}
        />
      )}
    </>
  )
}

export default MobileInvestAccountList
